import { defineMessages } from "react-intl";
import { defaultListMessages, ListMessages } from "../../shared/crud/list";
import { loyaltyTagCommonMessages } from "../common.messages";

export const loyaltyTagsListMessages: ListMessages = {
  ...defaultListMessages,
  entityName: {
    id: "loyaltyTags.title",
    defaultMessage: "Loyalty preferences list",
  },
  tableHeaders: {
    ticker: {
      id: "loyaltyTags.table.ticker",
      defaultMessage: "Id",
    },
    name: {
      id: "loyaltyTags.table.name",
      defaultMessage: "Name",
    },
  },
};

export const loyaltyTagsMessages = defineMessages({
  newPreference: {
    id: "loyaltyTags.newPreference",
    defaultMessage: "Create new",
  },
  newPreferencesExcel: {
    id: "loyaltyTags.newPreferencesExcel",
    defaultMessage: "Create preferences from Excel",
  },
  goBack: loyaltyTagCommonMessages.back,
  edit: loyaltyTagCommonMessages.edit,
});
